exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fabric-category[data-v-5bc2259e] {\n  width: 200px;\n}\n.fabric-number[data-v-5bc2259e] {\n  width: 300px;\n}\n.text-capitalize[data-v-5bc2259e] {\n  text-transform: capitalize;\n}\n.station-name[data-v-5bc2259e] {\n  width: 300px;\n}\n.modal-header .close[data-v-5bc2259e] {\n  margin-top: -21px !important;\n}\n", ""]);

// exports
